export default {
    filters: {
        reversed(date) {
            if (date != null) {
                return date.split('-').reverse().join('-')
            }
        }
    }
}